import * as mod from 'zepto';
if (false) {
  module.exports = mod.default;
} else {
  module.exports = mod;
}